import {Injectable} from '@angular/core';
import {env} from './env';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {NotificationsService} from './notifications.service';
import {UserSupportMetric} from '../model/metric/user-support-metric';
import {BehaviorSubject, EMPTY} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {UserSearchContext} from '../model/metric/user-search-context';
import {QueryContext} from '../state/model/entity-geo-area';
import {UserSupportAction} from '../model/metric/user-support-action';

@Injectable({
  providedIn: 'root'
})
export class UserMetricService {

  private urlAction= env.apiUrl + '/support-ui/track-user-action';
  private urlSearchContext= env.apiUrl + '/support-ui/track-context-search';

  userIsAuthenticated$ : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient,
              private notificationsService: NotificationsService) {}

  sendAction (action : string) {
    const userSupportMetric : UserSupportMetric = { action };
    return this.http
      .post(this.urlAction, userSupportMetric)
      .pipe(catchError(e => this.handleError(e)))
      .subscribe();
  }

  sendSearchContext (
    context : QueryContext
  ) {
    const unknown = 'N/A';
    const userSearchContext : UserSearchContext = {
      action: UserSupportAction.SEARCH,
      engine: context?.engine ? context.engine.valueOf() : unknown,
      type: context?.type ? context.type.valueOf() : unknown
    };
    return this.http
      .post(this.urlSearchContext, userSearchContext)
      .pipe(catchError(e => this.handleError(e)))
      .subscribe();
  }

  setUserIsAuthenticated(isAuth : boolean) {
    this.userIsAuthenticated$.next(isAuth);
  }

  handleError(error: HttpErrorResponse)  {
    console.error(`Backend returned code ${error.status}, body was: ${JSON.stringify(error)}`);
    this.notificationsService.error('Something wrong happened...', `Backend returned code ${error.status}`);
    return EMPTY;
  }
}
